import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;

  font-size: 18px;
  font-weight: 300;
  color: #1c1c1c;

  & .title {
    margin: 40px 0 10px;
    font-weight: 600;
    color: #000;
  }
`;

export default { Wrapper };
